import AddTestStepper from "../../components/add/AddTestStepper";
import {
  Box,
  Icon,
  IconButton,
  TextField,
  useTheme,
  Typography,
  ToggleButtonGroup,
  FormGroup,
  Switch,
  FormControlLabel,
  ToggleButton
} from "@mui/material";
import AddTestPageNavButtons from "./AddTestPageNavButtons";
import VideoCard, { LargeVideoCard } from "../global/VideoCard";
import theme from "tailwindcss/defaultTheme";
import { tokens } from "../../theme";
import DragDropFileUpload from "./DragDropFileUpload";
import { useContext, useState } from "react";
import { VideoContext } from "../../context/video_context";
import { Close } from "@mui/icons-material";

type UploadTestContent = {
  handlePageChangeUp: any;
  handlePageChangeDown: any;
  handlePageChange: any;
};

const activeStep: number = 1;

export default function UploadTestContent(fn: UploadTestContent) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const videoContext = useContext(VideoContext);
  const selectedVideo = videoContext?.selectedVideo;
  const titles = videoContext?.titles || [];
  const setTitles = videoContext?.setTitles || (() => {
  });

  const [title, setTitle] = useState("");

  function handleTitleChange(title: string) {
    setTitles((prev: any) => [...prev, title]);
    setTitle("");
  }

  return (
    <Box
      sx={{
        width: "100%",
        paddingY: 2,
        display: "flex",
        flexDirection: "column",
        height: "100%"
      }}
    >
      <AddTestStepper activeStep={activeStep} />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          paddingY: 2
        }}
      >
        <Box sx={{ paddingX: 6, paddingY: 4, flexGrow: 1 }}>
          {/* <Box>
            <Box
              sx={{
                fontSize: "h3.fontSize",
                paddingTop: 2,
                paddingBottom: 1,
              }}
            >
              Test Type
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyItems: "center",
                overflowY: "scroll",
                paddingLeft: "auto",
              }}
            >
              <Box
                sx={{
                  fontSize: "h4.fontSize",
                  paddingY: 2,
                  paddingX: 2,
                  border: `2px solid ${colors.primary[500]}`,
                  borderRadius: 2,
                  width: "150px",
                  height: "100px",
                  margin: 1,
                }}
              >
                Thumbnail
              </Box>
              <Box
                sx={{
                  fontSize: "h4.fontSize",
                  paddingY: 2,
                  paddingX: 2,
                  border: `2px solid ${colors.primary[500]}`,
                  borderRadius: 2,
                  width: "150px",
                  height: "100px",
                  margin: "10px",
                }}
              >
                Title
              </Box>
              <Box
                sx={{
                  fontSize: "h4.fontSize",
                  paddingY: 2,
                  paddingX: 2,
                  border: `2px solid ${colors.primary[500]}`,
                  borderRadius: 2,
                  width: "150px",
                  height: "100px",
                  margin: "10px",
                }}
              >
                Thumbnail + Title
              </Box>
            </Box>
          </Box> */}

          <Box
            sx={{
              paddingBottom: 2
            }}
          >
            <Box
              sx={{
                fontSize: "h3.fontSize",
                paddingBottom: 1
              }}
            >
              Thumbnails
            </Box>
            <DragDropFileUpload />
          </Box>
          <Box>
            <Box
              sx={{
                fontSize: "h3.fontSize",
                paddingBottom: 1
              }}
            >
              Titles
            </Box>
            <Box>
              {titles.map((title: string, ind: number) => {
                return (
                  <Box
                    sx={{
                      paddingBottom: 1,
                      paddingX: 1,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between"
                    }}
                  >
                    {title}
                    <IconButton
                      onClick={() =>
                        setTitles(
                          titles.filter((_: string, i: number) => i !== ind)
                        )
                      }
                    >
                      <Icon>
                        <Close />
                      </Icon>
                    </IconButton>
                  </Box>
                );
              })}
              <TextField
                sx={{
                  paddingBottom: 2,
                  width: "100%"
                }}
                size={"small"}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleTitleChange(title);
                  }
                }}
                placeholder="Add a title to test"
              ></TextField>
            </Box>
          </Box>
        </Box>
        <Box sx={{ marginLeft: "auto", padding: 6 }}>
          <VideoCard
            handlePageChangeUp={fn.handlePageChangeUp}
            views={selectedVideo?.views || "0"}
            uploaded={selectedVideo?.uploaded || new Date()}
            video_id={selectedVideo?.video_id || ""}
            title={selectedVideo?.title || ""}
            imgLink={selectedVideo?.imgLink || ""}
          />
        </Box>
      </Box>
      <AddTestPageNavButtons
        step={activeStep}
        handlePageChangeUp={fn.handlePageChangeUp}
        handlePageChangeDown={fn.handlePageChangeDown}
      />
    </Box>
  );
}
